import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const reviews = [{
  text: 'Mon fils de 7 ans a construit son premier robot en 20 minutes et ne réclame plus sa tablette depuis. C’est le meilleur investissement que j’ai fait comme parent.',
  name: 'Jessica M.',
  meta: 'Maman de 2 enfants · Texas, États-Unis',
  letter: 'J',
  color: 'bg-brand',
  textTone: 'text-white',
  tone: 'bg-brand-light'
}, {
  text: 'J’étais sceptique au début — « encore un produit numérique » — mais les guides sont si clairs que même moi, j’ai pu les suivre. Ma fille est conquise.',
  name: 'Sarah K.',
  meta: 'Maman de 3 enfants · Londres, Royaume-Uni',
  letter: 'S',
  color: 'bg-mint',
  textTone: 'text-ink',
  tone: 'bg-mint-light'
}, {
  text: 'Nous faisons désormais un projet chaque samedi matin. Mon fils appelle ça le « jour des robots ». En deux mois, il a appris plus sur l’ingénierie qu’en une année scolaire entière.',
  name: 'Michael R.',
  meta: 'Papa d’un enfant · Sydney, Australie',
  letter: 'M',
  color: 'bg-sky',
  textTone: 'text-ink',
  tone: 'bg-sky-light'
}, {
  text: 'Le tableau de progression offert est une idée brillante. Mes enfants se lancent des défis pour terminer le plus de projets. Les disputes autour des écrans ont presque disparu.',
  name: 'Rachel T.',
  meta: 'Maman de 4 enfants · Toronto, Canada',
  letter: 'R',
  color: 'bg-sunshine',
  textTone: 'text-ink',
  tone: 'bg-sunshine-light'
}, {
  text: 'Je l’ai téléchargé vendredi soir, imprimé le guide de démarrage rapide et, avant le coucher, nous avions un robot fonctionnel. Mon enfant de 5 ans était si fier. Cela vaut chaque centime.',
  name: 'Laura B.',
  meta: 'Maman de 2 enfants · Madrid, Espagne',
  letter: 'L',
  color: 'bg-coral',
  textTone: 'text-ink',
  tone: 'bg-coral-light'
}];
function Stars() {
  return <div className="flex text-amber-400" aria-hidden="true" data-id="element-179" data-mp="1xiitaylvbojr">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-180" data-mp="1sjz32m08rqll" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-181" data-mp="1ofhpx5oe0bjs">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-182" data-mp="1jj0ya1hzbf1y">
        <SectionHeading eyebrow="Ce que disent les parents" title={<>De vraies familles. De vrais résultats.</>} subtitle="Plus de 2 000 familles ont déjà utilisé MakerLab pour éloigner leurs enfants des écrans et construire quelque chose de concret. Voici leurs témoignages." data-id="element-183" data-mp="1jkkext7jrs49" />

        <div className="mt-8 flex items-center justify-center gap-3" data-id="element-184" data-mp="10s01nk4bzvlk">
          <Stars data-id="element-185" data-mp="10pnd2o42imzj" />
          <p className="text-sm font-semibold text-ink" data-id="element-186" data-mp="vsnf70hdgqji">
            Plus de 2 000 familles — 4,9 sur 5 de moyenne
          </p>
        </div>

        <div className="mt-12 columns-1 gap-6 sm:columns-2 lg:columns-3 [&>*]:mb-6" data-id="element-187" data-mp="qulpvxtcruzl">
          {reviews.map((r, i) => <motion.figure key={r.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i % 3 * 0.08
        }} className={`break-inside-avoid rounded-3xl border border-ink/10 p-6 ${r.tone}`} data-id="element-188" data-mp="32gntku1ohj4e" data-mpi={i}>
              <Stars data-id="element-189" data-mp="2sq1ind4wpgs1" />
              <blockquote className="mt-3 text-sm leading-relaxed text-ink/80" data-id="element-190" data-mp="2spjbvmkmbk5v">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3" data-id="element-191" data-mp="20zwpaoz65jeo">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold ${r.color} ${r.textTone}`} data-id="element-192" data-mp="20zoer3qiqq6n">
                  {r.letter}
                </span>
                <span data-id="element-193" data-mp="1lukck1zr9gey">
                  <span className="block text-sm font-bold text-ink" data-id="element-194" data-mp="1gybzcu54bxaf">
                    {r.name}
                  </span>
                  <span className="block text-xs text-ink/50" data-id="element-195" data-mp="1vnrl1vpslcj9">{r.meta}</span>
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}